import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { legalLinks } from '../../content'
import { footer, IDS } from '../content'
import { ink, line, soft, Wrap } from '../styled'

const Footer = styled.footer`
  padding: 28px 24px 32px;
  border-top: 1px solid ${line};
  color: ${soft};
  font-size: 13px;
  line-height: 1.5;

  ${Wrap} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 12px 24px;
  }

  p {
    margin: 0;
  }

  b {
    color: ${ink};
  }

  nav {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 18px;
  }

  a {
    color: ${soft};
  }

  a:hover {
    color: ${ink};
  }
`

const FooterSection = () => (
  <Footer id={IDS.footer}>
    <Wrap>
      <p>
        <b>{footer.brand}</b> {footer.tradingLine}
      </p>
      <nav aria-label={footer.navLabel}>
        <Link href="/">
          <a>{footer.home}</a>
        </Link>
        {legalLinks.map((link) => (
          <Link key={link.href} href={link.href}>
            <a>{link.label}</a>
          </Link>
        ))}
      </nav>
    </Wrap>
  </Footer>
)

export default FooterSection
